export default __webpack_public_path__ + "static/media/Melissa_Mobile.f28007c1.png";